"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var genderBuilder = function genderBuilder(_a) {
  var _b;

  var _c = _a.gender,
      gender = _c === void 0 ? [] : _c;

  if (gender.length === 0 || gender.includes(_SearchFilters.GenderValue.BOYS) && gender.includes(_SearchFilters.GenderValue.GIRLS)) {
    return '';
  }

  return (_b = {}, _b[_SearchFilters.GenderValue.BOYS] = "NOT preferredGender:" + _SearchFilters.GenderValue.GIRLS, _b[_SearchFilters.GenderValue.GIRLS] = "NOT preferredGender:" + _SearchFilters.GenderValue.BOYS, _b)[gender[0]];
};

var _default = genderBuilder;
exports["default"] = _default;